/** Message of a refused API call: DRF `{message}`, `{detail}`, `["…"]` or `{non_field_errors}`; else `fallback`. */
export function apiErrorMessage(error: unknown, fallback: string): string {
    const body = (error as { json?: unknown })?.json;
    if (Array.isArray(body) && typeof body[0] === "string") return body.join(" ");
    if (body && typeof body === "object") {
        const { message, detail, non_field_errors } = body as { message?: unknown; detail?: unknown; non_field_errors?: unknown };
        if (typeof message === "string") return message;
        if (typeof detail === "string") return detail;
        if (Array.isArray(non_field_errors) && typeof non_field_errors[0] === "string") return non_field_errors.join(" ");
    }
    return fallback;
}
